// Welcome message constants for Prototype Mode
export const WELCOME_MESSAGE_ID = 'welcome-message';
export const WELCOME_MESSAGE_TAP = `### Welcome to Prototype Mode

Hi, I'm your Tyler Application Platform Prototype Design Agent! Here is what I can do for you:

- Add Base and Child tracked objects (BTO/CTO) 
- Create and Update data elements (add, remove, and change types - including text, dropdowns, dates, checkboxes, lookups, etc.) 
- Update forms rules such as required fields and dynamic show / hide
- Add form columns, headers, case banner,  and form-queues 
- Create tables on the Home page and Tracking Inbox with sample data

I work exclusively on data models and forms-based prototypes. I don't touch workflows and business functions, which allows me to move incredibly fast.  When you are happy with your prototype, you can move it to Build Mode to turn it into a full feature application with a connected backend database.

Feel free to ask for guidance along the way! Now, what would you like to Prototype today?`;

export const WELCOME_MESSAGE_SERVICE_NOW = `### Welcome to Design Mode for ServiceNow
What would you like to build today?`;
export const WELCOME_MESSAGE_WEB = `### Welcome to Prototype Mode

Hi, I'm your Web Application Prototype Design Agent! Here is what I can do for you:

- Interactive Prototypes: I can build fully functional frontends with mock data, animations, and transitions so you can feel the user experience.
- Design Systems: I can set up typography, color palettes, and component libraries (using Shadcn/UI) to give your project a professional look that matches your organizational standards from day one.
- Visual Assets: I can generate custom images, backgrounds, and textures to match your design aesthetic.
- Iterate Quickly: I can instantly tweak layouts, change colors, or refactor components based on your feedback.
- Documentation: I can produce documents to assist you with Deliverables, your Requirements elaboration, or to support your Build.

I work exclusively on the frontend. I don't touch backend servers or databases, which allows me to move incredibly fast. When you are happy with your prototype, you can move it to build mode to turn it into a full feature application with a connected backend database.

Feel free to ask for guidance along the way! Now, what would you like to Prototype today?`;
